import { Action, createReducer, on } from '@ngrx/store';
import * as Actions from './coupon.actions';
import { Coupon } from '@core/models/swagger';
import cloneDeep from 'clone-deep';
import dayjs from 'dayjs';
import { Patterns } from '@global/enums';

export interface State {
  coupon: Coupon;
}

export const featureKey = 'flowDataCoupon';

export const initialState: State = {
  coupon: {},
};

export function couponReducer(state: State | undefined, action: Action): State {
  return createReducer(
    initialState,
    on(Actions.ResetCoupon, (state, {}) => ({
      ...state,
      coupon: {},
    })),
    on(Actions.UpdateCoupon, (state, { data }) => ({
      ...state,
      coupon: cloneDeep(data),
    }))
  )(state, action);
}
